import { apiClient, type RequestOptions } from '@/services/apiClient';
import type { ObservabilityCommandCenter } from './observability.types';

export const observabilityApi = {
  getDashboard: (options?: RequestOptions) => apiClient.get<ObservabilityCommandCenter>('/v1/observability/command-center', options),
  runPerformancePass: (_input: void, options?: RequestOptions) => apiClient.post<ObservabilityCommandCenter['passes'][number]>('/v1/observability/performance-pass', {}, options),
};
